import { BRANDS } from "../data/content";

export const BrandMarquee = () => {
  const loop = [...BRANDS, ...BRANDS, ...BRANDS, ...BRANDS];
  return (
    <div className="marquee-mask overflow-hidden" data-testid="brand-marquee-container" aria-label="Brands we source and distribute">
      <div className="marquee-track" style={{ "--marquee-duration": "60s" }}>
        {loop.map((b, i) => (
          <div key={i} className="flex h-24 lg:h-28 w-[150px] sm:w-[190px] lg:w-[220px] shrink-0 items-center justify-center" aria-hidden={i >= BRANDS.length}>
            <img
              src={b.src}
              alt={i < BRANDS.length ? `${b.name} logo` : ""}
              className="brand-logo h-auto max-h-14 object-contain"
              style={{ width: `clamp(${Math.round(b.w * 0.75)}px, ${(b.w / 14.4).toFixed(2)}vw, ${b.w}px)` }}
              loading="eager"
              data-testid={i < BRANDS.length ? `brand-logo-${b.name.toLowerCase().replace(/[^a-z]/g, "")}` : undefined}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export const TextMarquee = ({ words }) => {
  const loop = [...words, ...words, ...words, ...words];
  return (
    <div className="overflow-hidden border-y border-[var(--line)] py-7 lg:py-10" data-testid="editorial-marquee">
      <div className="marquee-track" style={{ "--marquee-duration": "110s" }}>
        {loop.map((w, i) => (
          <span key={i} className="flex shrink-0 items-center font-serif-display text-4xl sm:text-5xl lg:text-[4.5rem] whitespace-nowrap">
            <span className={i % 2 ? "outline-text" : ""}>{w}</span>
            <span className="mx-8 sm:mx-12 inline-block h-1.5 w-1.5 rounded-full bg-[var(--ink)] opacity-60" />
          </span>
        ))}
      </div>
    </div>
  );
};
